import { useState } from 'react';
import type { GenerateRoutineParams, Routine } from '@/api';
import { generateRoutine } from '@/api';

export const useGenerateRoutine = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const generate = async (params: GenerateRoutineParams): Promise<Routine | null> => {
    setIsLoading(true);
    setError(null);

    try {
      const routine = await generateRoutine(params);
      return routine;
    } catch (err) {
      setError(err as Error);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { generate, isLoading, error };
};
